import { AxiosError, AxiosResponse } from 'axios';

export const handleAxiosError = (error: AxiosError): void => {
  const { status, statusText, data } = error.response as AxiosResponse;

  console.error(
    JSON.stringify({
      'error-log': {
        message: 'clientAxios onResponseError',
        status,
        statusText,
        data,
      },
    })
  );
};

export const logUnknownError = (error: Error): void => {
  console.error(
    JSON.stringify({
      'error-log': {
        message: 'clientAxios unknown onResponseError',
        error: JSON.stringify(error),
      },
    })
  );
};
